<div class="bg-white p-4 shadow-sm rounded">
  <div>
    <span class="fw-extrabold fs-5">Monto ($)</span>
  </div>
  <canvas  id="line" >{{ chartLine }}</canvas>
</div>